import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // get key from URL
import axios from "axios";
import { Table, Spinner, Alert, Container } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Button, Col, FloatingLabel, Row, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const FamilyListPage = () => {
  const { key } = useParams(); // Example: verification-distributed
  const [families, setFamilies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchFamilyList();
  }, [key]);

  const fetchFamilyList = async () => {
    const AuthToken = localStorage.getItem("AuthUser");
    axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `/get-distributed-families/${key}`);
      if (response.data.success) {
        setFamilies(response.data.data);
      } else {
        setError(response.data.message || "Failed to load families.");
      }
    } catch (err) {
      setError("An error occurred while fetching families.");
    } finally {
      setLoading(false);
    }
  };

  return (

    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">  List of Families: {key.replaceAll("-", " ")}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"home"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"Finances"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{"Dashboard"}</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
      <Container className="mt-4">


        {loading && (
          <div className="text-center">
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        {error && (
          <Alert variant="danger" className="text-center">
            {error}
          </Alert>
        )}

        {!loading && !error && (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Family ID</th>
                <th>Name</th>
                <th>CNIC</th>
                <th>User</th>
                
                {/* Add more columns if needed */}
              </tr>
            </thead>
            <tbody>
              {families.length > 0 ? (
                families.map((family, index) => (
                  <tr key={family.id}>
                    <td>{index + 1}</td>
                    <td>{family.person?.f_number}</td>
                    <td>{family.person?.beneficiary_name || "N/A"}</td>
                    <td>{family.person?.cnic || "N/A"}</td>
                    <td>{family.user?.name || "N/A"}</td>
                    
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No families found for this category.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </Container>
    </PageLayout>
  );
};

export default FamilyListPage;
